import { render, staticRenderFns } from "./InventoryBalanceByProduct.vue?vue&type=template&id=1002aab0"
import script from "./InventoryBalanceByProduct.vue?vue&type=script&lang=js"
export * from "./InventoryBalanceByProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports